// Detect scroll and change header class
document.addEventListener("scroll", function () {
  var header = document.querySelector(".header-wrapper");
  if (window.scrollY > 50) {
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }
});
